import { paths } from '@/constants/paths'
import { Seo } from '@/layout/Seo'
import { useCanonicalUrl } from '@/layout/Seo/useCanonicalUrl/useCanonicalUrl'
import { LegalLayout } from '@/layouts/LegalLayout'
import { NextPageWithLayout } from '@/layouts/types'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { getGenericStaticPaths } from '@/utils/nextUtils/staticPages'
import { loadTranslations } from '@/utils/translate/translate-server'
import { TermsOfUse_2025_09_23 } from './2025-09-23'

export { TermsOfUse_2025_09_23 as CurrentTermsOfUse } from './2025-09-23'

const TermsOfUsePage: NextPageWithLayout = () => {
  const canonical = useCanonicalUrl(paths.legal.termsOfUse)
  const title = 'Terms of Use | Angel'

  return (
    <>
      <Seo
        canonical={canonical}
        title={title}
        description="Angel Terms of Use. Review the terms and conditions for using Angel services."
        openGraph={{
          title,
          url: canonical,
          site_name: 'Angel',
        }}
        path={paths.legal.termsOfUse}
      />
      <TermsOfUse_2025_09_23 />
    </>
  )
}

TermsOfUsePage.getLayout = (page) => {
  return <LegalLayout>{page}</LegalLayout>
}

export const getStaticProps = getStaticPropsErrorHandler(
  { filePath: 'pages/[locale]/legal/terms-of-use/index.tsx' },
  async ({ locale }) => {
    return {
      props: {
        ...(await loadTranslations(locale, ['common', 'account'])),
      },
      revalidate: false,
    }
  },
)

export const getStaticPaths = getGenericStaticPaths

export default TermsOfUsePage
